import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  TableCell,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import clsx from "clsx";
import UseMobile from "../../hooks/useIsMobile";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("md")]: {
      backgroundColor: "white",
    },
  },
  TableCell: {
    backgroundColor: theme.palette.primary.main,
    whiteSpace: "nowrap",
    [theme.breakpoints.down("md")]: {
      width: 500,
    },
  },
  title: {
    fontSize: "1rem",
    color: "white",
    whiteSpace: "nowrap",
  },
  srno: {
    paddingLeft: theme.spacing(1),
  },
}));

const TableHeader = ({ data, srnotitle, longFields }) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.only("xs"));

  const renderCell = (cell) => {
    return (
      <TableCell
        key={cell.key}
        width={100 * cell.width}
        className={clsx(classes.TableCell)}
      >
        <Typography
          className={classes.title}
          {...(longFields &&
            longFields.includes(JSON.stringify(cell.key)) && {
              style: { width: 150 },
            })}
        >
          {cell.title}
        </Typography>
      </TableCell>
    );
  };
  return (
    <TableHead>
      <TableRow>
        <TableCell
          padding="checkbox"
          className={clsx(classes.TableCell, classes.srno)}
        >
          <Typography className={classes.title}>{srnotitle}</Typography>
        </TableCell>
        {data?.map((cell, index) => {
          return renderCell(cell);
        })}
      </TableRow>
    </TableHead>
  );
};
export default TableHeader;
